module.exports = __webpack_public_path__ + "static/media/profile.aeef8fa9.svg";